module.exports = __webpack_public_path__ + "static/media/thunder-cloud-rain.1804ce74.png";